module.exports = __webpack_public_path__ + "static/media/thumb.74e1d746.PNG";